import styled from 'styled-components';

export const PhoneLabel = styled.div<{ color: string }>`
    align-self: start;
    font-size: ${({ theme }) => theme.fontSizes[3]};
    border-radius: 0.5rem;
    margin-top: 0.25rem;

    &::before {
        content: ' ';
        display: inline-block;
        margin-right: 0.25rem;
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
        background-color: ${({ color }) => color};
        margin-left: 0.25rem;
    }
`;

export const IconButton = styled.button`
    padding: 0;
    border: none;
    cursor: pointer;
`;
